module.exports = __webpack_public_path__ + "img/IMG_6941.aa0dc9cf.webp";